import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const BlogHero = dynamic(() => import('./blog-hero'));

Builder.registerComponent(BlogHero, {
  name: 'BlogHero',
  inputs: [
    {
      name: 'category',
      type: 'string',
      defaultValue: 'Blog',
    },
    {
      name: 'publishDate',
      type: 'date',
    },
    {
      name: 'readTime',
      type: 'number',
      defaultValue: 5,
    },
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'description',
      type: 'longText',
    },
    {
      name: 'heroImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'gif', 'webp'],
    },
    {
      name: 'author',
      type: 'object',
      subFields: [
        {
          name: 'name',
          type: 'string',
        },
        {
          name: 'portrait',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'gif', 'webp'],
        },
      ],
    },
    {
      name: 'backUrl',
      type: 'string',
      defaultValue: '/blog',
    },
  ],
});
